<template>
    <v-layout>
        <v-flex>
            <v-card>
                <v-card-title class="primary headline white--text">
                    Dynamic Control
                </v-card-title>

                <v-card-title class="accent title white--text">
                    Software Switches
                </v-card-title>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex v-for="s in switchesPoints" xs12 md6 :key="s.sensor_name">
                            <v-switch :disabled="!$can('update', 'SoftwareSwitches')" v-model="s.combinedVal"
                                      :label="s.sensor_name"
                                      @change="updateSwitch(s.sensor_id, s.combinedVal)"></v-switch>
                        </v-flex>
                    </v-layout>
                </v-card-text>

                <v-card-title class="title accent white--text">
                    Control Readings
                </v-card-title>
                <v-card-actions>
                    <loading-progress-bar :loading="loading"></loading-progress-bar>
                    <v-spacer></v-spacer>
                    <v-btn class="accent" @click="refresh()">Refresh</v-btn>
                </v-card-actions>
                <v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <div style="width:300px;" >
                            <v-text-field clearable v-model="search1" type="text" label="Keyword filter"></v-text-field>
                        </div>
                    </v-card-actions>

                    <v-data-table
                            :headers="headers"
                            :items="controlPoints"
                            :search="search1"
                            class="elevation-1"
                    >
                        <template v-slot:items="props">
                            <td class="text-xs-left">{{props.item.equipment_name}}</td>
                            <td>{{ props.item.sensor_name }}</td>
                            <td class="text-xs-left">{{ props.item.combinedVal }} {{props.item.unit}}</td>
                            <td class="text-xs-left">{{props.item.curStatus}}</td>
                            <td class="text-xs-left">{{props.item.curErr}}</td>
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="primary" @click="refresh">Reset</v-btn>
                        </template>
                    </v-data-table>

                </v-card-text>
                <v-card-title class="title accent white--text">
                    Sensor Readings
                </v-card-title>
                <v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <div style="width:300px;" >
                            <v-text-field clearable v-model="search2" type="text" label="Keyword filter"></v-text-field>
                        </div>
                    </v-card-actions>
                    <v-data-table
                            :headers="headers"
                            :items="points"
                            :search="search2"
                            class="elevation-1"
                    >
                        <template v-slot:items="props">
                            <td class="text-xs-left">{{props.item.equipment_name}}</td>
                            <td>{{ props.item.sensor_name }}</td>
                            <td class="text-xs-left">{{ props.item.combinedVal }} {{props.item.unit}}</td>
                            <td class="text-xs-left">{{props.item.curStatus}}</td>
                            <td class="text-xs-left">{{props.item.curErr}}</td>
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="primary" @click="refresh">Reset</v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-dialog v-model="dialog">

        </v-dialog>
    </v-layout>
</template>

<script>
    import _ from 'lodash'
    import {getOptimizationControl, putOptimizationControl} from '../helper'
    import LoadingProgressBar from '../components/LoadingProgressBar'

    export default {
        name: 'DynamicControlOutputPoints',
        components: {LoadingProgressBar},
        data: () => ({
            loading: true,
            dialog: false,
            search1:'',
            search2:'',
            headers: [
                {
                    text: 'Equipment Name',
                    align: 'left',
                    sortable: true,
                    value: 'equipment_name'
                },
                {text: 'Point Name', value: 'sensor_name'},
                {text: 'Value', value: 'combinedVal'},
                {text: 'Status', value: 'curStatus'},
                {text: 'Error', value: 'curErr'}
            ],
            points: [],
            editedIndex: -1,
            editedItem: {},
            defaultItem: {},
            switchesPoints: []
        }),
        methods: {
            async refresh() {
                this.loading = true
                this.points = (await getOptimizationControl(
                    {'facility_name': this.$store.state.pointsListStore.pointsList.facility_name}
                ))['result']
                this.loading = false
            },
            async updateSwitch(sensor_id, value) {
                await putOptimizationControl({
                    'sensor_id': sensor_id,
                    'value': value
                })
            }
        },
        computed: {
            controlPoints() {
                return _.filter(
                    this.points,
                    function (x) {
                        return ['Temp_Reset', 'Seq', 'Speed_SP', 'Seq', 'Nos_of_ACC_Req', 'CHW_Setpoint'].includes(x['sensor_name'])
                    }
                )
            },

        },
        async mounted() {
            await this.refresh()
            this.switchesPoints = _.filter(
                this.points,
                function (x) {
                    return x.meta.tags.includes('switchFlag')
                }
            )

        }
    }
</script>

<style scoped>

</style>
